import React from "react";
import styled from "styled-components";
import { Radio } from "react-radio-group";
import { IconRadioButtonSelected, IconRadioButtonUnselected, colorAttentionBlue50, colorFunctionalGray70, colorMiscBlue20, colorMiscGray40, spacingM, spacingS, } from "@rhumbix/rmbx_design_system_design_tokens";
export const RadioButtonWithLabel = (props) => {
    const { checked, disabled, indeterminate } = props;
    const radioStyles = {
        height: 20,
        width: 20,
        marginRight: spacingS,
    };
    let radioIcon = (React.createElement(IconRadioButtonUnselected, { style: { ...radioStyles, color: disabled ? colorMiscGray40 : colorFunctionalGray70 } }));
    if (indeterminate || checked) {
        radioIcon = (React.createElement(IconRadioButtonSelected, { style: {
                ...radioStyles,
                color: disabled ? colorMiscGray40 : indeterminate ? colorMiscBlue20 : colorAttentionBlue50,
            } }));
    }
    return (React.createElement(StyledLabel, { htmlFor: props.id },
        React.createElement(StyledRadio, { value: props.value, id: props.id, checked: !!props?.checked, onClick: props?.onClick, onChange: () => props?.onClick, disabled: props?.disabled }),
        radioIcon,
        props.labelText));
};
const StyledLabel = styled.label `
    min-width: 120px;
    color: ${colorFunctionalGray70};
    font-size: 14px;
    font-weight: 700;
    line-height: ${spacingM};
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${spacingM};

    &:hover {
        cursor: pointer;
    }

    input[type="radio"] {
        margin-left: 0px;
        margin-right: 8px;
        margin-bottom: 4px;
        position: absolute;
        opacity: 0;
    }
`;
const StyledRadio = styled(Radio) `
    height: 20px;
    width: 20px;

    &:hover {
        cursor: pointer;
    }
`;
export default RadioButtonWithLabel;
